import React from "react";
import { RaceWagerType } from "@tvg/ts-types/Race";
import { Icon, Paragraph, useColorTokens } from "@tvg/design-system";
import { DropdownSelectAllButton } from "../../styled-components";

interface DropdownElementProps {
  label: string;
  betType: RaceWagerType;
  isAllSelected: boolean;
  onClickSelectAll: () => void;
}

const DropdownElement = ({
  label,
  betType,
  isAllSelected,
  onClickSelectAll
}: DropdownElementProps) => {
  const colorTokens = useColorTokens();

  return (
    <DropdownSelectAllButton
      isSelected={isAllSelected}
      onClick={onClickSelectAll}
      data-qa-label={`${label}-${betType.type.code}-dropdown-button`}
    >
      <Icon
        name={isAllSelected ? "tick" : "plus"}
        size="s"
        mr={5}
        lineColor={
          isAllSelected
            ? colorTokens.component.button.buttonLink.content.base
            : colorTokens.content.default
        }
      />
      <Paragraph
        qaLabel={`${label}-select-all-dropdown-text`}
        color={
          isAllSelected
            ? colorTokens.component.button.buttonLink.content.base
            : colorTokens.content.default
        }
        fontSize="s"
        fontFamily={isAllSelected ? "medium" : "regular"}
      >
        {label}
      </Paragraph>
    </DropdownSelectAllButton>
  );
};

export default DropdownElement;
